import { RefreshCcw, Rocket } from 'lucide-react';
import { LoadingButton } from '@/shared/components/ui/buttons/loading-button';
import { Group } from '@/types/api/group';
import { OnboardingTaskStatus } from '@/types/api/group/onboarding-task';
import { onboardingLabel } from '../../utils/onboarding-labels';
import { OnboardingProgress } from './onboarding-progress';
import { TaskStatusIcon } from './onboarding-task-card';

type OnboardingWaitingProps = {
  group: Group;
  refetch: () => void;
  isRefetching: boolean;
};

/** For members while their leader is onboarding the group */
export function OnboardingWaiting({ group, refetch, isRefetching }: OnboardingWaitingProps) {
  const tasks = [...group.onboardingTasks].sort((a, b) => a.order - b.order);
  const remaining = tasks.filter((task) => task.status !== OnboardingTaskStatus.Completed).length;

  return (
    <div className="flex flex-col gap-6 p-4 max-w-md mx-auto h-full justify-center">
      <div className="flex flex-col items-center gap-4 text-center">
        <Rocket className="size-16 text-primary" />
        <h2 className="text-2xl font-bold">Gruppen är snart redo! ✨</h2>
        <p>
          Er ledare har {remaining} steg kvar. Så fort allt är på plats får du tillgång
          till er försäljning.
        </p>
      </div>

      <div className="rounded-xl bg-white dark:bg-gray-800 shadow-sm p-5 space-y-4">
        <OnboardingProgress tasks={tasks} title={group.name} />
        <ul className="space-y-3">
          {tasks.map((task) => (
            <li key={task.key} className="flex items-center gap-3 text-sm">
              <TaskStatusIcon status={task.status} />
              {onboardingLabel(task.key)}
            </li>
          ))}
        </ul>
      </div>

      <LoadingButton onClick={() => refetch()} isLoading={isRefetching} variant="outline" className="self-center">
        <RefreshCcw />
        Ladda om
      </LoadingButton>
    </div>
  );
}
